import { map } from 'rxjs/operators';
import { AnnualPlanStatusEntry, MatrixCellData, MetricData } from '../omnidashboard.models';
import { buildAnnualPlanStatusMap, resolveAnnualPlanMetric } from './annual-plan-status.metric';
import { OmniMetricLoader, OmniMetricLoaderDeps } from './metric-loader';

export const ANNUAL_PLAN_STATUS_LOADER: OmniMetricLoader = {
  key: 'annual-plan-status',
  load(deps: OmniMetricLoaderDeps) {
    const requestDTO = { filter: { fiscalYear: deps.selectedFiscalYear } };
    return deps.hoshinBudgetService.getAllChapterBudgetStatuses(requestDTO).pipe(
      map((items: AnnualPlanStatusEntry[]) => {
        const statusMap = buildAnnualPlanStatusMap(Array.isArray(items) ? items : []);
        return (cell: MatrixCellData): MetricData => resolveAnnualPlanMetric(statusMap, cell);
      })
    );
  },
};
